import * as Sentry from '@sentry/react';

import { resetFeatureFlagsCache } from '../hooks/useFeatureFlags';

// Logout is a plain `{ type: 'CLEAR_DATA' }` dispatched from several
// components without a page reload. Reducers reset redux; this middleware
// resets the session state that lives OUTSIDE redux, in one place, so no
// logout site can forget it.
const CLEAR_DATA = 'CLEAR_DATA';

const sessionResetMiddleware = () => (next) => (action) => {
  if (action && action.type === CLEAR_DATA) {
    try {
      resetFeatureFlagsCache();
    } catch (error) {
      // A failed cache reset must never block the logout itself.
      Sentry.captureException(error, {
        tags: { component: 'sessionResetMiddleware', op: 'reset_feature_flags_cache' },
      });
    }
  }
  return next(action);
};

export default sessionResetMiddleware;
